import { PiGraduationCap } from "react-icons/pi";
import {
  BarChartIcon,
  DashboardIcon,
  PhoneIcon,
  settingsIcon,
  RepresentativeIcon,
  SparkleIcon,
  DebriefIcon,
} from "../assets/icons/audio-icons";
import FinancialInsights from "../views/financial-insights/FinancialInsights";
import FinancialDetails from "../views/financial-insights/FinancialDetails";
import Lists from "../views/calls/Lists";
import Settings from "../views/settings/Settings";
import Dashboard from "../views/dashboard/Dashboard";
import Calls from "../views/calls/Calls";
import Representatives from "../views/representatives/Representatives";
import LiveContentSearch from "../views/live-content-search";
import Debriefs from "../views/debriefs/Debriefs";
import DebriefDetail from "../views/debriefs/DebriefDetail";
import Insights from "../views/insights";
import Training from "../views/training";

import { PERMISSIONS } from "../hooks/usePermissions";

const dashRoutes = [
  {
    name: "Dashboard",
    path: "/dashboard",
    element: <Dashboard />,
    icon: DashboardIcon,
    permissions: PERMISSIONS.USER,
  },
  {
    name: "Insights",
    path: "/insights",
    featureFlag: "insights",
    element: <Insights />,
    icon: BarChartIcon,
    permissions: PERMISSIONS.SUPER_ADMIN,
  },
  {
    name: "Calls",
    path: "/calls",
    element: <Calls />,
    icon: PhoneIcon,
    permissions: PERMISSIONS.USER,
    children: [
      {
        name: "Lists",
        path: "/calls/lists",
        element: <Lists />,
        icon: null,
        permissions: PERMISSIONS.SUPER_ADMIN,
        managerOnly: true,
        subRoutes: [
          {
            name: "Lists",
            path: "/calls/lists/:listId",
            element: <Lists />,
            icon: null,
            permissions: PERMISSIONS.SUPER_ADMIN,
          },
        ],
      },
    ],
    subRoutes: [
      {
        name: "callDeepLink",
        path: ":callId",
        element: <Calls />,
        permissions: PERMISSIONS.USER,
      },
    ],
  },
  {
    name: "Representatives",
    path: "/representatives",
    element: <Representatives />,
    icon: RepresentativeIcon,
    permissions: PERMISSIONS.USER,
    managerOnly: true,
    subRoutes: [
      {
        name: "representativesDeepLink",
        path: ":representativeId",
        element: <Representatives />,
        permissions: PERMISSIONS.USER,
      },
    ],
  },
  {
    name: "Debriefs",
    path: "/debriefs",
    element: <Debriefs />,
    icon: DebriefIcon,
    permissions: PERMISSIONS.SUPER_ADMIN,
    managerOnly: true,
    easierAdminOnly: false,
    subRoutes: [
      {
        name: "debriefDeepLink",
        path: ":debriefId",
        element: <DebriefDetail />,
        permissions: PERMISSIONS.SUPER_ADMIN,
      },
    ],
  },
  {
    // Formation: voice-simulation training. Hidden unless the company enables
    // feature_flags.training; open to every user (agent view), the manager view needs
    // ADMIN_TRAINING. Inner routes (/training/*) are handled by the module itself.
    name: "Training",
    path: "/training",
    element: <Training />,
    icon: PiGraduationCap,
    permissions: PERMISSIONS.USER,
    featureFlag: "training",
    subRoutes: [
      {
        name: "trainingDeepLink",
        path: "*",
        element: <Training />,
        permissions: PERMISSIONS.USER,
      },
    ],
  },
  {
    name: "Live Content Search",
    path: "/live-content-search",
    element: <LiveContentSearch />,
    icon: SparkleIcon,
    permissions: PERMISSIONS.USER,
    subRoutes: [
      {
        name: "liveContentSearchDeepLink",
        path: ":callId",
        element: <LiveContentSearch />,
        permissions: PERMISSIONS.USER,
      },
    ],
  },
  {
    name: "Financial Insights",
    path: "/financials",
    element: <FinancialInsights />,
    icon: BarChartIcon,
    permissions: PERMISSIONS.USER,
    defendedPermissions: PERMISSIONS.NO_FINANCIAL,
    featureFlag: "financial_insights",
    children: [
      {
        name: "Details",
        path: "/financials/details",
        element: <FinancialDetails />,
        icon: null,
        permissions: PERMISSIONS.ADMIN,
        defendedPermissions: PERMISSIONS.NO_FINANCIAL,
        managerOnly: true,
      },
    ],
  },
  {
    name: "Settings",
    path: "/settings",
    element: <Settings />,
    icon: settingsIcon,
    permissions: PERMISSIONS.SUPER_ADMIN,
    subRoutes: [
      {
        name: "settingsDeeplink",
        path: ":operatorId",
        element: <Settings />,
        permissions: PERMISSIONS.SUPER_ADMIN,
      },
    ],
  },
];
export default dashRoutes;
